import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getNewAddedItemsTotal } from 'entities/CatalogItem/model/selectors/catalogItemSelectors';

interface ReviewOrderFooterProps {
    children: ReactNode;
    leadingAction?: ReactNode;
}

export const ReviewOrderFooter = ({
    children,
    leadingAction,
}: ReviewOrderFooterProps) => {
    const { t } = useTranslation();
    const totalSelected = useSelector(getNewAddedItemsTotal);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                width: '100%',
                borderRadius: '0 0 12px 12px',
                border: '1px solid',
                borderColor: 'divider',
                p: '16px',
                backgroundColor: 'background.paper',
            }}
            data-testid="add-review-order-footer"
        >
            {leadingAction}
            {totalSelected > 0 ? (
                <Typography
                    variant="body2"
                    sx={{
                        color: 'common.black',
                        marginLeft: leadingAction ? '16px' : 0,
                    }}
                >
                    {t('{{count}} item selected', { count: totalSelected })}
                </Typography>
            ) : null}
            <Box sx={{ marginLeft: 'auto' }}>{children}</Box>
        </Box>
    );
};
